import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import __ from 'lodash';

import router from '../router/index.js';

Vue.use(Vuex)

const USER_DATA = () => {
  return {
    id: void 0,
    grade: void 0,
    name: void 0,
    url: void 0,
  }
}
const PRODUCT_CATEGORY = () => {
  return {
    id: void 0,
    name: void 0,
  }
}

// const PRODUCT = () => {
//   return {
//     id
//     name
//     categoryUid
//     productCode
//     deliveryPrice
//     allowance
//     vedioUrl
//     deliveryText1
//     deliveryText2
//     deliveryText3
//     rank
//     isSoldout
//     tag
//     createdAt
//     updatedAt
//     prices
//     images
//   }
// }

export default new Vuex.Store({
  state: {
    user: USER_DATA(), // 기본 유저 정보

    productCategories: [], // 상품 카테고리 목록
    currentProductCategory: PRODUCT_CATEGORY(), // 최근 방문한 카테고리 정보
    currentProduct: {}, // 최근 조회한 상품 정보
    currentSearchQuery: '', // 최근 검색 키워드
  },
  getters: {
  },
  mutations: {
    setUser(state, user) { // 유저 정보 저장
      state.user.id = user.id;
      state.user.grade = user.grade;
      state.user.name = user.name;
      state.user.url = user.url;
    },
    delUser(state) {
      state.user = USER_DATA();

      state.productCategories = [];
      state.currentProductCategory = PRODUCT_CATEGORY();
    },

    setCategories(state, categories) { // 카테고리 정보 저장
      state.productCategories = categories;
    },
    updateCurrentProductCategory(state, category) { // 최근 방문한 카테고리 정보 갱신
      state.currentProductCategory.id = category.id;
      state.currentProductCategory.name = category.name;
    },
    updateCurrentProduct(state, product) {
      state.currentProduct = product
    },
    changeCurrentSearchQuery(state, query) { // 최근 검색 키워드 변경
      state.currentSearchQuery = query;
    }, 
  },
  actions: {
    async setUser({commit}) { // 유저 정보 저장
      // 유저 정보 조회
      try {
        const res = await axios.get('/api/v1/users/my-info');
        commit('setUser', res.data);
      } catch (err) {
        router.go(0);        
      }
    },
    delUser({commit}) { // 유저 정보 삭제
      commit('delUser', {});
    },
    async logout({commit}) { // 로그아웃
      await axios.get('/api/v1/auth/logout');
      commit('delUser', {});
      router.go(0);
    },
    async withdrawal({commit}) { // 회원탈퇴
      // await axios.get('/api/v1/auth/logout');
      // commit('delUser', {});
      // router.go(0);
    },

    setCategories({commit}, categories) { // 카테고리 정보 저장
      commit('setCategories', __.cloneDeep(categories));
    },
    updateCurrentProductCategory({commit}, category) { // 최근 방문한 카테고리 정보 갱신
      commit('updateCurrentProductCategory', __.cloneDeep(category));
    },
    updateCurrentProduct({commit}, product) {
      commit('updateCurrentProduct', __.cloneDeep(product));
    },
    changeCurrentSearchQuery({commit}, query) { // 최근 검색 키워드 변경
      commit('changeCurrentSearchQuery', query);
    },
  },
  modules: {
  },
  plugins: [createPersistedState()],
})
